import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  badge: {
    display: 'inline-block',
    padding: '2px 10px',
    borderRadius: 'var(--border-radius-sm)',
    fontSize: 'var(--text-size-xs)',
    fontWeight: 600,
    textTransform: 'capitalize'
  },
  running: {
    backgroundColor: 'var(--color-info-050, #eff6ff)',
    color: 'var(--color-info-700, #1d4ed8)'
  },
  complete: {
    backgroundColor: 'var(--color-success-050, #f0fdf4)',
    color: 'var(--color-success-700, #15803d)'
  },
  failed: {
    backgroundColor: 'var(--color-danger-050, #fef2f2)',
    color: 'var(--color-danger-700, #b91c1c)'
  },
  cancelled: {
    backgroundColor: 'var(--color-neutral-050)',
    color: 'var(--color-neutral-500)'
  },
  pending: {
    backgroundColor: 'var(--color-neutral-100)',
    color: 'var(--color-neutral-600)'
  }
}))

function StatusBadge ({ status }) {
  const classes = useStyles()
  const variant = classes[status] || classes.pending
  return <span className={`${classes.badge} ${variant}`}>{status || 'pending'}</span>
}

StatusBadge.propTypes = {
  status: PropTypes.oneOf([
    'pending',
    'running',
    'complete',
    'failed',
    'cancelled',
    'error',
    'assistant_error',
    'assistant_running',
    'judging'
  ])
}

export default StatusBadge
